import axios from 'axios'

/**
 * Asks the administrators of the company this address belongs to for access. Anonymous, and
 * the endpoint answers the same way whatever it decided to do (sent, no such account, already
 * active, or a repeat inside its cooldown), so neither the call nor its answer can be used to
 * find out whether an address has an account. The copy shown afterwards says as much.
 */
export const requestAccess = async (email: string): Promise<void> => {
  await axios.post(`${process.env.REACT_APP_API_URL}/core/request-access`, { email })
}

export interface IPlatformAccessRequest {
  platform: 'slack' | 'google' | 'microsoft'
  /** The Slack user token, Google ID token or Microsoft access token from the sign-in that just ended on no access. */
  token: string
}

/**
 * Asks to be added to the company whose Slack workspace, Google domain or Microsoft tenant the
 * visitor just signed in with. The token is the proof: the endpoint verifies it and works out the company itself, so
 * the ask cannot reach any other company. It answers the same way whatever it decided to do.
 */
export const requestPlatformAccess = async (request: IPlatformAccessRequest): Promise<void> => {
  await axios.post(`${process.env.REACT_APP_API_URL}/core/request-access`, request)
}
